import {
  GeneralIcon
} from "./chunk-JQYOYMSZ.mjs";

// src/icon/src/general/info.tsx
import { jsx } from "react/jsx-runtime";
var Path = () => /* @__PURE__ */ jsx(
  "path",
  {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm.2 4.17a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm1.88 11.25h-3.33a.83.83 0 0 1 0-1.67h.63a.2.2 0 0 0 .2-.2v-3.76a.2.2 0 0 0-.2-.2h-.63a.83.83 0 0 1 0-1.67h.83a1.67 1.67 0 0 1 1.67 1.66v3.96a.2.2 0 0 0 .2.21h.63a.83.83 0 1 1 0 1.67Z",
    fill: "currentColor"
  }
);
var InfoIcon = (props) => /* @__PURE__ */ jsx(GeneralIcon, { ...props, children: /* @__PURE__ */ jsx(Path, {}) });

export {
  InfoIcon
};
